import { GetDrakeTaxReturnFileInputsRequest } from '@taxfyle/api-internal/internal/tax_preparation_pb'
import Job from './Job'
import { Id } from 'types/definitions'
import { WorkAPI } from './API'

interface DrakeTaxReturnFileInput {
  screenReference: string
  stateCode: string
  occurrence: number
  fieldNumber: number
  format: number
  value: string
}

export interface DrakeTaxReturnFileInputs {
  filename: string
  inputs: DrakeTaxReturnFileInput[]
}

export default class TaxPreparationStore {
  constructor(private api: WorkAPI) {}

  async downloadDrakeTaxReturn(job: Job): Promise<void> {
    const request = new GetDrakeTaxReturnFileInputsRequest().setJobId(
      Id.assert(job.id),
    )

    const { filename, inputs } = await this.api.taxPreparation
      .getDrakeTaxReturnFileInputs(request)
      .then((response) => ({
        filename: response.getFilename(),
        inputs: response
          .getInputsList()
          .map((input) =>
            [
              input.getScreenReference(),
              input.getStateCode(),
              input.getOccurrence(),
              input.getFieldNumber(),
              input.getFormat(),
              `"${input.getValue().replace(/"/g, '""')}"`,
            ].join(','),
          )
          .join('\n'),
      }))

    const drakeBlob = new Blob([inputs], {
      type: 'application/octet-stream',
    })

    const link = document.createElement('a')
    link.download = filename
    link.href = URL.createObjectURL(drakeBlob)
    link.style.display = 'none'

    document.body.appendChild(link)

    link.click()

    setTimeout(() => {
      URL.revokeObjectURL(link.href)
      link.parentNode?.removeChild(link)
    })
  }
}
